import React, {useEffect} from "react";


export default function InpostGeowidget(props: InpostGeowidgetProps) {
    useEffect(() => {
        const css: HTMLLinkElement = document.createElement("link"),
            js: HTMLScriptElement = document.createElement("script"),
            body: HTMLElement = document.getElementsByTagName("body")[0];

        (window as any).onInpostChange = props.onChange;


        css.rel = "stylesheet";
        css.href = `${process.env.REACT_APP_INPOST_LINK!}.css`;
        css.type = "text/css";

        js.defer = true;
        js.src = `${process.env.REACT_APP_INPOST_LINK!}.js`;

        body.appendChild(css);
        body.appendChild(js);

        return () => {
            body.removeChild(css);
            body.removeChild(js);
        }
    }, []);

    return React.createElement("inpost-geowidget", {
        token: props.token,
        onpoint: "onInpostChange",
        language: props.language,
        config: props.config
    });
}

interface InpostGeowidgetProps {
    token: string;
    onChange: (e: InpostPointType) => void;
    language?: "pl" | "en";
    config?: config;
}

type config =
    "parcelCollect"
    | "parcelCollectPayment"
    | "parcelCollect247"
    | "parcelSend"
    | "parcelCollectZabka"
    | "parcelCollectPaymentZabka"
    | "parcelCollectInPost"
    | "parcelCollectPaymentInPost"


export interface Location {
    longitude: number;
    latitude: number;
}

export interface Address {
    line1: string;
    line2: string;
}

export interface AddressDetails {
    city: string;
    province: string;
    post_code: string;
    street: string;
    building_number: string;
    flat_number?: any;
}

export interface OperatingHoursExtended {
    customer?: any;
}

export interface InpostPointType {
    href: string;
    name: string;
    type: string[];
    status: string;
    location: Location;
    location_type?: any;
    location_date?: any;
    location_description: string;
    location_description_1?: any;
    location_description_2?: any;
    distance: number;
    opening_hours: string;
    address: Address;
    address_details: AddressDetails;
    phone_number?: any;
    payment_point_descr: string;
    functions: string[];
    partner_id: number;
    is_next: boolean;
    payment_available: boolean;
    payment_type: any;
    virtual: string;
    recommended_low_interest_box_machines_list?: any;
    apm_doubled?: any;
    location_247: boolean;
    operating_hours_extended: OperatingHoursExtended;
    agency: string;
    image_url: string;
    easy_access_zone: boolean;
    air_index_level?: any;
    physical_type: string;
    physical_type_mapped: string;
    physical_type_description?: any;
    in_mobile_collect_excluded?: any;
    in_mobile_send_excluded?: any;
    in_mobile_return_excluded?: any;
    express_delivery_send: boolean;
    express_delivery_collect: boolean;
}


